const map = {
	"./Smiley_angry.svg": [
		121,
		[
			121
		]
	],
	"./Smiley_happy.svg": [
		352,
		[
			352
		]
	],
	"./Smiley_love.svg": [
		234,
		[
			234
		]
	],
	"./Smiley_normal.svg": [
		367,
		[
			367
		]
	],
	"./Smiley_sad.svg": [
		438,
		[
			438
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76;
module.exports = webpackAsyncContext;